// extracted by mini-css-extract-plugin
export default {"container":"application_container__eIuWq"};